
/* eslint-disable max-nested-callbacks, max-len */

import qs from 'qs';

const Promise = require('bluebird');

export const concatAll = (array) => {
    const results = [];
    array.forEach(subArray => results.push(...subArray));
    return results;
};

export const concatMap = (array, projectionFunction) =>
    concatAll(array.map(item => projectionFunction(item)));

export const extendClass = (ChildClass, ParentClass) => {
    ChildClass.prototype = new ParentClass();
    ChildClass.prototype.constructor = ChildClass;
};

function getNavigationStateObject(config, user) {
    return {
        dropdown: {
            isVisible: false,
            linkGroups: [2]
        },
        helpDropdown: {
            isVisible: false,
            linkGroups: [3]
        },
        mobHelpDropdown: {
            isVisible: false,
            linkGroups: [3]
        },
        venueDropdown: {
            isVisible: false,
            linkGroups: [1]
        },
        mobVenueDropdown: {
            isVisible: false,
            linkGroups: [1]
        },
        perfDropdown: {
            isVisible: false,
            linkGroups: [4]
        },
        mobPerfDropdown: {
            isVisible: false,
            linkGroups: [4]
        },
        invoiceDropdown: {
            isVisible: false,
            linkGroups: [5]
        },
        mobInvoiceDropdown: {
            isVisible: false,
            linkGroups: [5]
        },
        inventDropdown: {
            isVisible: false,
            linkGroups: [6]
        },
        mobInventDropdown: {
            isVisible: false,
            linkGroups: [6]
        },
        adminHelpDropdown: {
            isVisible: false,
            linkGroups: [7]
        },
        mobAdminHelpDropdown: {
            isVisible: false,
            linkGroups: [7]
        },
        linkGroups: [
            {
                id: 1,
                title: { transKey: 'nav.venue' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'nav.listings' },
                        url: `/${config.domain}/dashboard/listings`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: { transKey: 'nav.reviews' },
                        url: `/${config.domain}/dashboard/reviews`,
                        shown: true
                    },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'nav.members' },
                        url: `/${config.domain}/dashboard/members`,
                        shown: true
                    },
                    {
                        id: 4,
                        icon: '',
                        title: { transKey: 'nav.add_new_listing' },
                        url: `/${config.domain}/dashboard/listings`,
                        shown: true
                    }
                ]
            },
            {
                id: 2,
                title: { transKey: 'User Actions' },
                links: [
                    {
                        id: 1,
                        icon: 'person',
                        title: { transKey: 'nav.dashboard' },
                        url: `/${config.domain}/dashboard`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: { transKey: 'nav.account_settings' },
                        url: `/${config.domain}/dashboard/edit-profile`,
                        shown: true
                    },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'nav.company_dashboard' },
                        url: `/${config.domain}/business/menu`,
                        shown: user.isDscAdmin
                    },
                    {
                        id: 4,
                        icon: '',
                        title: { transKey: 'nav.billing_payouts' },
                        url: `/${config.domain}/dashboard/billing-payouts`,
                        shown: user.isVenueOwner
                    },
                    {
                        id: 5,
                        icon: '',
                        title: { transKey: 'nav.reviews' },
                        url: `/${config.domain}/dashboard/reviews`,
                        shown: !user.isVenueOwner
                    },
                    {
                        id: 6,
                        icon: '',
                        title: { transKey: 'common.logout' },
                        url: `/${config.domain}/users/logout`,
                        shown: true
                    }
                ]
            },
            {
                id: 3,
                title: { transKey: 'common.help' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'common.faq' },
                        url: `/${config.domain}/faq`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: {
                            transKey: 'common.phone_display',
                            replacements: { phoneNumber: config.phone.phoneNumberDisplay },
                            count: 1
                        },
                        url: `tel:${config.phone.phoneNumber}`,
                        shown: true
                    }
                ]
            },
            {
                id: 4,
                title: { transKey: 'Performance' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'Performance' },
                        url: `/${config.domain}/administrator`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: { transKey: 'Finance' },
                        url: `/${config.domain}/administrator/payments/summary`,
                        shown: true
                    },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'Performance (GS)' },
                        url: `/${config.domain}/administrator/google_studio/performance`,
                        shown: true
                    },
                    {
                        id: 4,
                        icon: '',
                        title: { transKey: 'Reviews (GS)' },
                        url: `/${config.domain}/administrator/google_studio/reviews`,
                        shown: true
                    }
                ]
            },
            {
                id: 5,
                title: { transKey: 'Payments' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'Payouts' },
                        url: `/${config.domain}/administrator/payouts`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: { transKey: 'Outstanding Payouts' },
                        url: `/${config.domain}/administrator/payouts/all`,
                        shown: true
                    },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'Financial Entities' },
                        url: `/${config.domain}/administrator/financial_entities`,
                        shown: true
                    },
                    {
                        id: 4,
                        icon: '',
                        title: { transKey: 'Unpaid invoices (GS)' },
                        url: `/${config.domain}/administrator/google_studio/invoices`,
                        shown: true
                    }
                ]
            },
            {
                id: 6,
                title: { transKey: 'Inventory' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'Locations' },
                        url: `/${config.domain}/administrator/locations`,
                        shown: true
                    },
                    // {
                    //     id: 2,
                    //     icon: '',
                    //     title: { transKey: 'Landing Pages' },
                    //     url: `/${config.domain}/administrator/landings`,
                    //     shown: true
                    // },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'Venues' },
                        url: `/${config.domain}/administrator/venues`,
                        shown: true
                    },
                    {
                        id: 4,
                        icon: '',
                        title: { transKey: 'Rooms' },
                        url: `/${config.domain}/administrator/rooms`,
                        shown: true
                    },
                    {
                        id: 5,
                        icon: '',
                        title: { transKey: 'Venue Photos' },
                        url: `/${config.domain}/administrator/photos/venues`,
                        shown: true
                    },
                    {
                        id: 6,
                        icon: '',
                        title: { transKey: 'Room Photos' },
                        url: `/${config.domain}/administrator/photos/rooms`,
                        shown: true
                    },
                    {
                        id: 7,
                        icon: '',
                        title: { transKey: 'Venues (GS)' },
                        url: `/${config.domain}/administrator/google_studio/venues`,
                        shown: true
                    },
                    {
                        id: 8,
                        icon: '',
                        title: { transKey: 'Rooms Tags (GS)' },
                        url: `/${config.domain}/administrator/google_studio/rooms`,
                        shown: true
                    },
                    {
                        id: 9,
                        icon: '',
                        title: { transKey: 'Rooms Approval (GS)' },
                        url: `/${config.domain}/administrator/google_studio/rooms_approval`,
                        shown: true
                    },
                    {
                        id: 10,
                        icon: '',
                        title: { transKey: 'Asset Photos (GS)' },
                        url: `/${config.domain}/administrator/google_studio/asset_photos`,
                        shown: true
                    },
                    {
                        id: 12,
                        icon: '',
                        title: { transKey: 'Landing Pages (GS)' },
                        url: `/${config.domain}/administrator/google_studio/landing_pages`,
                        shown: true
                    },
                    {
                        id: 13,
                        icon: '',
                        title: { transKey: 'Tags (GS)' },
                        url: `/${config.domain}/administrator/google_studio/tags`,
                        shown: true
                    }
                ]
            },
            {
                id: 7,
                title: { transKey: 'Helpers' },
                links: [
                    {
                        id: 1,
                        icon: '',
                        title: { transKey: 'Import Calendar' },
                        url: `/${config.domain}/administrator/import_calendar`,
                        shown: true
                    },
                    {
                        id: 2,
                        icon: '',
                        title: { transKey: 'Issue Reports' },
                        url: `/${config.domain}/administrator/issue_reports`,
                        shown: true
                    },
                    {
                        id: 3,
                        icon: '',
                        title: { transKey: 'Heatmap' },
                        url: `/${config.domain}/administrator/heatmap`,
                        shown: true
                    }
                ]
            }
        ]
    };
}

export const getNavigationState = (config, user) => {
    return new Promise(resolve => {
        resolve({
            data: getNavigationStateObject(config, user)
        });
    });
};

export const createFiltersQueryStringFromArray = (searchParams, filterGroupCollections) => {
    const params = window.location.search.split('?')[1];
    const paramsObj = qs.parse(params);
    const filters = {
        ...searchParams,
        ...paramsObj
    };
    delete filters.location;
    delete filters.tag;
    delete filters.page;
    filters.lang = paramsObj.lang;
    filters.lat = paramsObj.lat;
    filters.lon = paramsObj.lon;
    if (paramsObj.ne_lat) {
        filters.ne_lat = paramsObj.ne_lat;
    }
    if (paramsObj.ne_long) {
        filters.ne_long = paramsObj.ne_long;
    }
    if (paramsObj.sw_lat) {
        filters.sw_lat = paramsObj.sw_lat;
    }
    if (paramsObj.sw_lon) {
        filters.sw_lon = paramsObj.sw_lon;
    }
    filterGroupCollections.map(filterGroupCollection => {
        filterGroupCollection.filterGroups.map(filterGroup => {
            if (filterGroup.inputType === 'slider') {
                filterGroup.filters.map(filter => {
                    filter.data.values.map(value => {
                        filters[value.slug] = value.value;
                    });
                });
            } else {
                const activeFilters = filterGroup.filters.filter(filter => {
                    if (filter.data.type === 'number') {
                        if (filter.data.value !== filter.data.default) {
                            return filter.data.value;
                        }
                        return;
                    }
                    return filter.data.value;
                });
                if (activeFilters && activeFilters.length) {
                    activeFilters.map(activeFilter => {
                        if (filterGroup.inputType === 'increment' || filterGroup.inputType === 'toggle-switch' || filterGroup.inputType === 'dropdown') {
                            filters[filterGroup.slug] = activeFilter.data.value;
                            return;
                        } else {
                            filters[filterGroup.slug] = filters[filterGroup.slug] ? filters[filterGroup.slug] : [];
                            if (filters[filterGroup.slug].filter(item => {
                                return Number(item) === Number(activeFilter.contextId);
                            }).length === 0) {
                                filters[filterGroup.slug].push(Number(activeFilter.contextId));
                                return;
                            } else {
                                filters[filterGroup.slug] = filters[filterGroup.slug].filter(item => {
                                    return Number(item) === Number(activeFilter.contextId);
                                });
                                return;
                            }
                        }
                    });
                } else if (Array.isArray(filters[filterGroup.slug])) {
                    const filterContextIds = [];
                    filterGroup.filters.map(filter => {
                        filterContextIds.push(filter.contextId);
                    });
                    filters[filterGroup.slug] = filters[filterGroup.slug].filter(item => {
                        return filterContextIds.indexOf(Number(item)) === -1;
                    });
                    return;
                } else if ((filterGroup.slug === 'all-day' || filterGroup.slug === 'live-availability') && filters[filterGroup.slug]) {
                    delete filters[filterGroup.slug];
                }
            }
        });
    });
    if (filters['all-day']) {
        delete filters.time;
        delete filters.duration;
    }
    return qs.stringify(filters, { arrayFormat: 'brackets' });
};

export const createFiltersQueryStringFromObject = (searchParams, filterGroupCollection) => {
    const params = window.location.search.split('?')[1];
    const paramsObj = qs.parse(params);
    const filters = {
        ...paramsObj
    };
    delete filters.location;
    delete filters.tag;
    delete filters.page;
    filters.lang = paramsObj.lang;
    filters.lat = paramsObj.lat;
    filters.lon = paramsObj.lon;
    if (paramsObj.ne_lat) {
        filters.ne_lat = paramsObj.ne_lat;
    }
    if (paramsObj.ne_long) {
        filters.ne_long = paramsObj.ne_long;
    }
    if (paramsObj.sw_lat) {
        filters.sw_lat = paramsObj.sw_lat;
    }
    if (paramsObj.sw_lon) {
        filters.sw_lon = paramsObj.sw_lon;
    }
    filterGroupCollection.filterGroups.map(filterGroup => {
        if (filterGroup.inputType === 'slider') {
            filterGroup.filters.map(filter => {
                filter.data.values.map(value => {
                    filters[value.slug] = value.value;
                });
            });
        } else {
            const activeFilters = filterGroup.filters.filter(filter => {
                if (filter.data.type === 'number') {
                    if (filter.data.value !== filter.data.default) {
                        return filter.data.value;
                    }
                    return;
                }
                return filter.data.value;
            });
            if (activeFilters && activeFilters.length) {
                activeFilters.map(activeFilter => {
                    if (filterGroup.inputType === 'increment' || filterGroup.inputType === 'toggle-switch' || filterGroup.inputType === 'dropdown') {
                        filters[filterGroup.slug] = activeFilter.data.value;
                        return;
                    } else {
                        filters[filterGroup.slug] = filters[filterGroup.slug] ? filters[filterGroup.slug] : [];
                        if (filters[filterGroup.slug].filter(item => {
                            return Number(item) === Number(activeFilter.contextId);
                        }).length === 0) {
                            filters[filterGroup.slug].push(Number(activeFilter.contextId));
                            return;
                        } else {
                            filters[filterGroup.slug] = filters[filterGroup.slug].filter(item => {
                                return Number(item) === Number(activeFilter.contextId);
                            });
                            return;
                        }
                    }
                });
            } else if (Array.isArray(filters[filterGroup.slug])) {
                const filterContextIds = [];
                filterGroup.filters.map(filter => {
                    filterContextIds.push(filter.contextId);
                });
                filters[filterGroup.slug] = filters[filterGroup.slug].filter(item => {
                    return filterContextIds.indexOf(Number(item)) === -1;
                });
                return;
            } else if ((filterGroup.slug === 'all-day' || filterGroup.slug === 'live-availability') && filters[filterGroup.slug]) {
                delete filters[filterGroup.slug];
            }
        }
    });
    if (filters['all-day']) {
        delete filters.time;
        delete filters.duration;
    }
    return qs.stringify(filters, { arrayFormat: 'brackets' });
};

export const convertLocationStringToSlug = location =>
    location.replace(/-/g, '~').replace(/[, ]/g, '-').replace(/[/()]/g, '');

export const convertLocationSlugToString = location =>
    location.replace(/--/g, ', ').replace(/-/g, ' ').replace(/~/g, '-');

export const capitalizeString = string => string.replace(/\b\w/g, l => l.toUpperCase());

export const convertTagStringToSlug = event =>
    event.toLowerCase().replace(/-/g, '~').replace(/[, ]/g, '-').replace(/[/()]/g, '');

export const convertTagSlugToString = event =>
    event.toLowerCase().replace(/--/g, ', ').replace(/-/g, ' ').replace(/~/g, '-');

export const convertVenueNameToSlug = name => {
    return encodeURIComponent(name.toLowerCase().replace(/[, _]/g, '-').replace(/[/()%:\\\\]/g, ''));
};

export const sendEvent = (apiUrl, { data, type }) => {
//    axios({
//        method: 'POST',
//        url: `${apiUrl}interactions/assets/${type}`,
//        data,
//        validateStatus: status => {
//            return status;
//        }
//    })
//        .catch(console.log);
};

export const sendImpressionEventBatch = (apiUrl, impressionEvents) => {
//    axios({
//        method: 'POST',
//        url: `${apiUrl}interactions/assets/impressions`,
//        data: {
//            impressions: impressionEvents
//        },
//        validateStatus: status => {
//            return status;
//        }
//    })
//        .catch(console.log);
};

export const undefinedStringHandler = string =>
    typeof string === 'undefined' || string === null ? '' : string;

export const doesExist = object => object ? true : false;

export const hasContents = array => array.length ? true : false;

export const notNull = item => item !== null;

export const getNestedObject = (nestedObj, pathArr) => pathArr.reduce((obj, key) =>
    (obj && obj[key] !== 'undefined') ? obj[key] : null, nestedObj);



// WEBPACK FOOTER //
// ./src/methods/index.js